import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { PermissionGroupsService } from "../Services/PermissionGroups.service";
import { PERMISSION_GROUPS_QUERY_KEY } from "../constants";
import { IEditPermissionGroup } from "@shared/lib/types/permissions";

export function useEditPermissionGroup() {
  const {
    mutate: editPermissionGroup,
    isLoading: isEditing,
    isSuccess: isEdited,
    isError: isEditFailed,
    variables,
  } = useMutation({
    mutationFn: async (permissionGroup: IEditPermissionGroup) => {
      return await PermissionGroupsService.editPermissionGroup(
        permissionGroup
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: PERMISSION_GROUPS_QUERY_KEY,
    },
    onSuccess: (c) => {},
  });

  return {
    editPermissionGroup,
    isEditing,
    isEdited,
    isEditFailed,
    variables,
  };
}
